<template>
<div>
  <div class="card">
    <div class="card-header">
      <div class="card-title">
        Configurações da Empresa / Concessionária
      </div>
    </div>

    <div class="card-content">
      <div class="form-group">
        <p>Nome completo da empresa</p>
        <input
          type="text"
          name="empresa-longname"
          v-model="project.company.longname"
          class="form-control"
        >
      </div>
      <div class="form-group">
        <p>Abreviação da empresa:</p>
        <input
          type="text"
          name="empresa-abbreviation"
          v-model="project.company.abbreviation"
          class="form-control"
        >
      </div>
      <div class="form-group">
        <p>CNPJ</p>
        <input
          type="text"
          name="empresa-cnpj"
          v-model="project.company.cnpj"
          class="form-control"
        >
      </div>
      <div class="form-group">
        <p>Número Estadual</p>
        <input
          type="text"
          name="empresa-numberState"
          v-model="project.company.numberState"
          class="form-control"
        >
      </div>
      <div class="form-group">
        <div class="card">
          <div class="card-header">
            <div class="card-title">
              Endereço
            </div>
          </div>
        </div>
        <div class="card-content">
          <div class="form-group">
            <p>Tipo de Logradouro</p>
            <input
              type="text"
              name="empresa-type"
              v-model="project.company.address.type"
              class="form-control"
              pĺaceholder="Avenida/Rodovia/Rua"
            />
          </div>
          <div class="form-group">
            <p>Logradouro</p>
            <input
              type="text"
              name="empresa-address-street"
              v-model="project.company.address.street"
              class="form-control"
              pĺaceholder="Augusto Montenegro"
            />
          </div>

          <div class="form-group">
            <p>Número</p>
            <input
              type="text"
              name="empresa-address-number"
              v-model="project.company.address.number"
              class="form-control"
              pĺaceholder="1000/Km 8"
            />
          </div>

          <div class="form-group">
            <p>Complemento</p>
            <input
              type="text"
              name="empresa-address-complement"
              v-model="project.company.address.complement"
              class="form-control"
              pĺaceholder="Sala 504"
            />
          </div>

          <div class="form-group">
            <p>Bairro</p>
            <input
              type="text"
              name="empresa-address-neighborhood"
              v-model="project.company.address.neighborhood"
              class="form-control"
              pĺaceholder="Conjunto Habitacional Casa Feliz"
            />
          </div>
          <div class="form-group">
            <p>Cidade</p>
            <select
              name="empresa-address-city"
              required
              v-model="project.company.address.city"
              class="form-control"
              id="empresa-address-city"
            >
              <option
                v-for="(city, index) in cities"
                :key="index"
                :value="city"
              >{{city}}
              </option>
            </select>
          </div>
          <div class="form-group">
            <p>Estado</p>
            <input
              readonly
              type="text"
              name="empresa-address-state"
              v-model="project.company.address.state"
              class="form-control"
              pĺaceholder="Conjunto Habitacional Casa Feliz"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'CompanyInfoForm',
  computed: {
    project: {
      get () {
        return this.$store.state.project.one
      }
    },
    ...mapGetters('states', ['cities'])
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Trg/Project/CompanyInfoForm.vue